import {
  CREATE_SUB_WINERY_SUCCESS,
  IS_LOADING_CREATE_SUB_WINERY,
  IS_LOADING_LIST_SUB_WINERIES,
  LIST_OF_SUB_WINERIES,
  IS_LOADING_DELETE_SUB_WINERY,
  DELETE_SUB_WINERY_SUCCESS,
  IS_LOADING_ONLY_SUB_WINERY,
  GET_ONLY_ONE_SUB_WINERY,
  IS_LOADING_SUBWINERIES_BY_NAME,
  LIST_OF_SUBWINERIES_BY_NAME,
  CLEAR_SUB_WINERIES
} from "../actions/types";

const initialState = {
  isLoadingCreateSubWinery: false,
  isLoadingListSubWineries: false,
  subWineriesList: [],
  isLoadingDeleteSubwinery: false,
  isLoadingGetOnlySubWinery: false,
  isLoadingSubWineryListByName: false,
};
export default function (state = initialState, action) {
  switch (action.type) {
    case IS_LOADING_CREATE_SUB_WINERY:
      return { ...state, isLoadingCreateSubWinery: true };
    case CREATE_SUB_WINERY_SUCCESS:
      return { ...state, isLoadingCreateSubWinery: false };
    case IS_LOADING_LIST_SUB_WINERIES:
      return { ...state, isLoadingListSubWineries: true };
    case LIST_OF_SUB_WINERIES:
      return {
        ...state,
        isLoadingListSubWineries: false,
        subWineriesList: action.payload,
      };

    case IS_LOADING_SUBWINERIES_BY_NAME:
      return { ...state, isLoadingSubWineryListByName: true };
    case LIST_OF_SUBWINERIES_BY_NAME:
      return {
        ...state,
        subWineriesList: action.payload,
        isLoadingSubWineryListByName: false,
      };

      case CLEAR_SUB_WINERIES:
        return {...state, subWineriesList:[]}

    case IS_LOADING_DELETE_SUB_WINERY:
      return { ...state, isLoadingListSubWineries: true };
    case DELETE_SUB_WINERY_SUCCESS:
      const newSubWineryList = state.subWineriesList.filter(
        (item) => item["_id"] !== action.payload.Id
      );
      return {
        ...state,
        isLoadingDeleteWinery: false,
        subWineriesList: newSubWineryList,
      };
    case IS_LOADING_ONLY_SUB_WINERY:
      return { ...state, isLoadingGetOnlySubWinery: true };
    case GET_ONLY_ONE_SUB_WINERY:
      return {
        ...state,
        isLoadingGetOnlySubWinery: false,
        subWineriesList: action.payload.data,
      };
    default:
      return state;
  }
}
